export const APP_ACCESS_TOKEN = '//EasyAuto2021.$//';

export const ONESIGNAL_APP_ID = "5f76c4db-aa95-4954-9489-9eed2c209648"; /* OPENSIGNAL PRODUCCION */
//export const ONESIGNAL_APP_ID = "46d3209b-890e-4780-8b99-bc2cf4f6f84d"; /* OPENSIGNAL DE PRUEBAS */

//export const BE_URL = "https://6jf7mmvc-8080.use2.devtunnels.ms";
//export const BE_URL = "http://192.168.1.102:8080";
export const BE_URL = "https://eaapi.ees.com.co";
